// Only opaque pointers belong here. Task/history/PageContext stay out of storage.
const PREFIX = "abos:admin-ai:conversation:v1:";
const identity = /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/;
const conversation = /^aic_[A-Za-z0-9_-]{1,46}$/;

export function conversationScope(user, workspace, store) {
  const ids = [user?.public_id, workspace?.public_id, store?.public_id];
  return ids.every((id) => typeof id === "string" && identity.test(id)) ? ids.join(":") : null;
}

export function readConversationPointer(scope) {
  if (!scope) return null;
  try {
    const value = localStorage.getItem(PREFIX + scope);
    if (value && conversation.test(value)) return value;
    if (value != null) localStorage.removeItem(PREFIX + scope);
  } catch { /* Storage may be unavailable; the server session still works. */ }
  return null;
}

export function writeConversationPointer(scope, id) {
  if (!scope || !conversation.test(id || "")) return;
  try { localStorage.setItem(PREFIX + scope, id); } catch { /* Optional persistence. */ }
}

export function clearConversationPointer(scope) {
  if (!scope) return;
  try { localStorage.removeItem(PREFIX + scope); } catch { /* Optional persistence. */ }
}

export function clearConversationPointers(userId = null) {
  try {
    const prefix = PREFIX + (userId ? `${userId}:` : "");
    Object.keys(localStorage).filter((key) => key.startsWith(prefix)).forEach((key) => localStorage.removeItem(key));
  } catch { /* Logout must still complete with blocked storage. */ }
}
